import React from 'react';

import * as s from './Labels.css';

/**
 * Лейбл "Автор"
 */
export const AuthorLabel = () => <div className={`${s['wrapper']} ${s['author']}`}>Автор</div>;
